import connect from 'components/lib/connect';
import UpdateAgentStatus from 'actions/liveboards/update_agent_status';
import { AgentAvailability } from 'models/agent_status';
import AgentOnCallWarningModal from 'components/modals/agent_on_call_warning_modal';

function mapStateToProps(context) {
  const modalAttrs = context.getProvider('modal').get();
  const { agentId, reasonId } = modalAttrs;

  return { agentId, reasonId };
}

function mapExecuteToProps(executeAction, { onClose }) {
  function setAwayStatus(agentId, reasonId) {
    executeAction(UpdateAgentStatus, {
      agentId,
      newStatus: AgentAvailability.AWAY,
      reasonId,
    });
    onClose();
  }

  return {
    onClose,
    setAwayStatus,
  };
}

function mergeProps({ agentId, reasonId }, { onClose, setAwayStatus }) {
  function onConfirm() {
    setAwayStatus(agentId, reasonId);
  }

  return {
    onClose,
    onConfirm,
  };
}

export default connect(mapStateToProps, mapExecuteToProps, mergeProps)(AgentOnCallWarningModal);
